import React from 'react';
import i18n from 'micro-i18n';
import PropTypes from 'prop-types';
import { IconCSLogo } from 'components/icons/Icons';
//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/callout/Callout.scss';

const Callout = ({targetId, publisherUrl}) => {
  if (!targetId || !publisherUrl) {
    return null;
  }

  const publisherUrlParams = `?utm_source=${targetId}&utm_medium=widget&utm_campaign=get_widget`;
  const calloutUrl = `${publisherUrl}${publisherUrlParams}`;

  return (
    <div className="csw-callout toggle-hover">
      <a aria-label={i18n.t('ADD_THIS_WIDGET')}
         title={i18n.t('ADD_THIS_WIDGET')}
         href={calloutUrl}
         target="_blank"
         rel="noopener noreferrer"
         className="csw-callout-link outline">
        <span className="csw-callout-txt hover-show">{i18n.t('GET')}</span>
        <IconCSLogo/>
      </a>
    </div>
  );
};

Callout.propTypes /* remove-proptypes */ = {
  targetId: PropTypes.string.isRequired,
  publisherUrl: PropTypes.string.isRequired
};

export default Callout;
